module.exports = __webpack_public_path__ + "static/img/nav_bg_fixed.f62fde98.png";